/** 供方平台路由 */
export const supplyRoutes = {
  /** 收据 */
  SupplyReceipt: '/supply/platform/receipt/list',
  /** 利润核算 */
  SupplyPurchaseOrderProfitAccountingList: '/supply/purchase_order/profit_accounting/list',
  /** 委外任务 */
  SupplyOutsourceTaskList: '/supply/outsource_task/list',
  /** 委外收入列表 */
  SupplyOutsourceIncomeList: '/supply/outsource/income/list',
  /** 成本记录列表 */
  SupplyCostRecordList: '/supply/purchase_order/cost_record/list',
  /** 新品提报 */
  SupplyNewSubmissionList: '/supply/commodity/new_submission/list',
  /** 质检报告（批次） */
  SupplyQualityInspectionBatchList: '/supply/commodity/quality_inspection_batch/list',
  /** 质检报告（批次）详情 */
  SupplyQualityInspectionBatchDetail: '/supply/commodity/quality_inspection_batch/detail',
  /** 上传质检报告 */
  SupplyQualityInspectionBatchCreate: '/supply/commodity/quality_inspection_batch/create',
  /** 编辑质检报告（批次） */
  SupplyQualityInspectionBatchEdit: '/supply/commodity/quality_inspection_batch/edit',
  /** 采购商品备注 */
  SupplyPurchaseSkuRemarkList: '/supply/purchase_order/purchase_sku_remark/list',
  /** 采购明细表 */
  SupplyPurchaseDetailReportList: '/supply/report/purchase_detail_report/list',
  /** 库存明细表 */
  SupplyStockDetailReportList: '/supply/report/stock_detail_report/list',
  /** 项目公示列表 */
  SupplyProjectPublicList: '/supply/report/project_public/list',
  /** 项目公示结果 */
  SupplyProjectPublicResult: '/supply/report/project_public/result',
  /** 项目列表 */
  SupplyProjectManageList: '/supply/inquiry_quotation/project_manage/list',
  /** 项目详情 */
  SupplyProjectManageDetail: '/supply/inquiry_quotation/project_manage/detail',
  /** 项目详情-单号查询 */
  SupplyProjectManageDetailByNo: '/supply/inquiry_quotation/project_manage/detail_no',
  /** 滞销品列表 */
  SupplyDeadStockList: '/supply/commodity/dead_stock/list',
  /** 商品税率 */
  SupplyTaxRateList: '/supply/commodity/tax_rate/list',
  /** 报餐记录 */
  SupplyMealRecordList: '/supply/purchase_order/meal_record/list',
  /** 报餐记录详情 */
  SupplyMealRecordDetail: '/supply/purchase_order/meal_record/detail',
  /** 套餐需求汇总 */
  SupplyPackageSummaryList: '/supply/purchase_order/package_summary/list',
  /** 套餐管理 */
  SupplyPackageManageList: '/supply/commodity/package_manage/list',
  /** 新建套餐 */
  SupplyPackageManageCreate: '/supply/commodity/package_manage/create',
  /** 套餐详情 */
  SupplyPackageManageDetail: '/supply/commodity/package_manage/detail',
  /** 套餐编辑 */
  SupplyPackageManageEdit: '/supply/commodity/package_manage/edit',
  /** 财务汇总表 */
  SupplyFinancialReportList: '/supply/report/financial_report/list',
  /** 询价公示 */
  SupplyInquiryPublic: '/supply/report/inquiry_public/list',
  /** 公示结果 */
  SupplyPublicResult: '/supply/report/inquiry_public/result',
  /** 收支管理 */
  SupplyIncomeExpenseList: '/supply/bill/income_expense/list',
  /** 周转筐管理 */
  SupplyTurnoverBasketList: '/supply/turnover_basket/list',
  /** 周转筐详情 */
  SupplyTurnoverBasketDetail: '/supply/turnover_basket/detail',
  /** 新建周转筐借还记录 */
  SupplyTurnoverBasketCreate: '/supply/turnover_basket/create',
  /** 编辑周转筐借还记录 */
  SupplyTurnoverBasketEdit: '/supply/turnover_basket/edit',
  /** 周转筐统计 */
  SupplyBasketStatisticsList: '/supply/basket_statistics/list',
  /** 员工管理 */
  SupplierEmployeeList: '/supply/setting/employee/list',
  /** 商品列表 */
  SupplyUnsuperviseCommodityList: '/supply/unsupervise_commodity/list',
  /** 创建商品 */
  SupplyUnsuperviseCommodityCreate: '/supply/unsupervise_commodity/create',
  /** 编辑商品 */
  SupplyUnsuperviseCommodityUpdate: '/supply/unsupervise_commodity/update',
  /** 商品详情 */
  SupplyUnsuperviseCommodityDetail: '/supply/unsupervise_commodity/detail',
  /** 采购单编辑 */
  SupplyPurchaseOrderEdit: '/supply/purchase_order/edit',
  /** 报价管理 */
  QuotationList: '/supply/inquiry_quotation/quotation/list',
  /** 质检报告 */
  CommodityQualityReportList: '/supply/commodity/quality_inspection/list',
  /** 询价单详情 */
  SupplyInquiryDetail: '/supply/inquiry_quotation/inquiry/detail',
  /** 询价单复制 */
  SupplyInquiryCopy: '/supply/inquiry_quotation/inquiry/copy',
  /** 询价列表 */
  SupplyAdminInquiryList: '/supply/inquiry_quotation/inquiry/list',
  /** 报价单列表 */
  SupplyQuotationList: '/supply/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  SupplyQuotationDetail: '/supply/inquiry_quotation/quotation/detail',
  /** 报价单详情 */
  SupplyQuotationDetailByNo: '/supply/inquiry_quotation/quotation/detail_no',
  /** 报价单编辑 */
  SupplyQuotationUpdate: '/supply/inquiry_quotation/quotation/update',
  /** 报价单创建 */
  SupplyQuotationCreate: '/supply/inquiry_quotation/quotation/create',
  /** 报价单创建 */
  SupplyQuotationCreateByInquiry: '/supply/inquiry_quotation/quotation/create_by_inquiry',
  /** 报价单创建 */
  SupplyQuotationCreateByProject: '/supply/inquiry_quotation/quotation/create_by_project',
  /** 报价单复制 */
  SupplyQuotationCopy: '/supply/inquiry_quotation/quotation/copy',
  /** 新建采购合同 */
  SupplyPurchaserContractCreate: '/supply/purchase_contract/create',
  /** 采购合同列表 */
  SupplyPurchaserContractList: '/supply/purchase_contract/list',
  /**
   * 采购合同详情
   * @param string id 采购合同id
   * @description 使用方式 ${SupplyPurchaserContractDetail}/${id}
   * */
  SupplyPurchaserContractDetail: '/supply/purchase_contract/detail',
  /** 采购合同详情-通过编号查询 */
  SupplyPurchaserContractDetailByNo: '/supply/purchase_contract/detail_no',
  /**
   * 编辑采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${SupplyPurchaserContractEdit}/${id}
   * */
  SupplyPurchaserContractEdit: '/supply/purchase_contract/edit',
  SupplyPurchaserContractCopy: '/supply/purchase_contract/copy',
  ReconciliationListForSupply: '/supply/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetailForSupply}/${statementNo}
   * */
  ReconciliationDetailForSupply: '/supply/bill/reconciliation/detail',
  /** 采购单列表 */
  SupplyPurchaseOrderList: '/supply/purchase_order/list',
  /** 供方预警-质检报告缺失（采购单） */
  SupplyWarningQualityReportMissingList: '/supply/warning/quality_report_missing',
  /** 供方预警-差评采购单 */
  SupplyWarningBadReviewsPurchaseList: '/supply/warning/bad_reviews_purchase',
  /** 供方预警-逾期送达 */
  SupplyWarningOverdueDeliveryPurchaseList: '/supply/warning/overdue_delivery_purchase',
  /** 供方预警-少送错送 */
  SupplyWarningLessDeliveryPurchaseList: '/supply/warning/less_delivery_purchase',
  /** 供方预警-包装破损 */
  SupplyWarningDamagedPackagePurchaseList: '/supply/warning/damaged_package_purchase',
  /** 供方预警-温湿度不达标 */
  SupplyWarningTemperatureHumidityPurchaseList: '/supply/warning/temperature_humidity_purchase',
  /** 供方预警-健康证过期 */
  SupplyWarningHealthCertExpiredList: '/supply/warning/health_cert_expired',
  /** 采购单详情 */
  SupplyPurchaseOrderDetail: '/supply/purchase_order/detail',
  /** 采购汇总表 */
  SupplyPurchaseReportList: '/supply/report/purchase_report/list',
  /** 经营分析 */
  SupplyBusinessAnalysisList: '/supply/report/business_analysis/list',
  /** 采购需求汇总 */
  PurchaseRequireSummary: '/supply/purchase_order/summary/list',
  /** 应收汇总 */
  ReceivableSummary: '/supply/bill/receivable/list',
  /** 开票记录列表 */
  BillRecordList: '/supply/bill/bill_record/list',
  /** 开票记录详情 */
  BillRecordDetail: '/supply/bill/bill_record/detail',
  /** 开票记录创建 */
  BillRecordCreate: '/supply/bill/bill_record/create',
  /** 开票记录编辑 */
  BillRecordEdit: '/supply/bill/bill_record/edit',
  /** 角色创建 */
  SupplyRoleCreate: '/supply/role/create',
  /** 角色列表 */
  SupplyRoleList: '/supply/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  SupplyRoleEdit: '/supply/role/editor',
  /** 车辆 */
  SupplyDeliveryCarList: '/supply/delivery_car/list',
  /** 配送任务 */
  SupplyDeliveryTaskList: '/supply/delivery_task/list',
  /** 新建配送任务 */
  SupplyDeliveryTaskCreate: '/supply/delivery_task/create',
  /** 编辑配送任务 */
  SupplyDeliveryTaskEdit: '/supply/delivery_task/edit',
  /** 配送任务详情 */
  SupplyDeliveryTaskDetail: '/supply/delivery_task/detail',
  /** 配送任务一键排线 */
  SupplyDeliveryTaskQuickWiring: '/supply/delivery_task/quick_wiring',
  /** 配送路线列表 */
  SupplyDeliveryRouteList: '/supply/delivery_route/list',
  /** 新建配送路线 */
  SupplyDeliveryRouteCreate: '/supply/delivery_route/create',
  /** 编辑配送路线 */
  SupplyDeliveryRouteEdit: '/supply/delivery_route/edit',
  /** 配送路线详情 */
  SupplyDeliveryRouteDetail: '/supply/delivery_route/detail',
  /** 监管方实时监控全屏 */
  SupplyRealtimeMonitor: '/supply/monitor/realtime_monitor',
  /** 监管方实时监控全屏 */
  SupplyRealtimeMonitorFullScreen: '/supply/monitor/realtime_monitor_full_screen',
  /** 工单 */
  SupplyWorkOrder: '/supply/platform/work_order/list',
  /** 入库单详情 */
  SupplyInboundOrderDetail: '/supply/inventory/inbound_order/detail',
  /** 出库单详情 */
  SupplyOutboundOrderDetail: '/supply/inventory/outbound_order/detail',
  /** 货源管理 */
  SupplyInventorySourceManageList: '/supply/inventory/source_manage/list',
  /** 新建货源 */
  SupplyInventorySourceManageCreate: '/supply/inventory/source_manage/create',
  /** 编辑货源 */
  SupplyInventorySourceManageEdit: '/supply/inventory/source_manage/edit',
  /** 补货单列表 */
  SupplyInventoryReplenishmentOrderList: '/supply/inventory/replenishment_order/list',
  /** 补货单详情 */
  SupplyInventoryReplenishmentOrderDetail: '/supply/inventory/replenishment_order/detail',
  /** 补货单新建 */
  SupplyInventoryReplenishmentOrderCreate: '/supply/inventory/replenishment_order/create',
  /** 补货单编辑 */
  SupplyInventoryReplenishmentOrderEdit: '/supply/inventory/replenishment_order/edit',
  /** 补货单完成 */
  SupplyInventoryReplenishmentOrderComplete: '/supply/inventory/replenishment_order/complete',
  /** 补货规则 */
  SupplyReplenishmentRules: '/supply/inventory/replenishment_rules/list',
};
